import { Injectable } from '@angular/core';
import { ApiService } from '../abstract/api-service.abstract';
import { Observable } from 'rxjs/internal/Observable';
import { map, tap } from 'rxjs/operators';
import { Dashboard } from '../models/dashboard.models';
import { DashboardPraModels } from '../models/dashboard-pra.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardService extends ApiService {
  getDashboard(): Observable<Dashboard> {
    const url = `${this.apiFrontUrl}/dashboard?date=${this.cacheUid()}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        if (data) {
          return Dashboard.fromJson(data);
        }
        return data;
      }),
    );
  }

  getValidityProject(params: {
    take: number;
    skip: number;
  }): Observable<{ data: DashboardPraModels[]; count: number }> {
    const url = `${this.apiFrontUrl}/dashboard/validity-projects/list?date=${this.cacheUid()}`;
    return this.http.get<any>(url, { params }).pipe(
      map((res) => ({
        data: Array.isArray(res.data)
          ? res.data.map((item: any) => DashboardPraModels.fromJson(item))
          : [],
        count: res.count ?? 0,
      })),
    );
  }
}
